import React from 'react';
import { InputNumber, Tooltip } from '@meitu/saas-ui';
import IconFont from '@meitu/xdesign-icon-font';
import { useLocaleStore } from '@/i18n';
import './style.less';

type Spacing = 'lineSpacing' | 'letterSpacing';

type Props = {
    lineSpacing: number;
    letterSpacing: number;
    onChange: (kind: Spacing, value: number) => void;
    onAfterChange: (kind: Spacing, value: number) => void;
};

export const TextSpacingGroup: React.FC<Props> = ({ lineSpacing, letterSpacing, onChange, onAfterChange }) => {
    const { $t } = useLocaleStore();

    const handleChange = (kind: Spacing, value: number | null) => {
        if (value === null) return;
        onChange(kind, value);
    };

    const handleAfterChange = (kind: Spacing, value: number | null) => {
        if (value === null) return;
        onAfterChange(kind, value);
    };

    return (
        <div className="text-spacing-group">
            <div className="text-spacing-group__actions">
                <Tooltip placement="bottom" title={$t((v) => v.textAction.rowSpacing)}>
                    <div className="text-spacing-group__action">
                        <InputNumber
                            min={-150}
                            max={300}
                            value={lineSpacing}
                            onChange={(value) => handleChange('lineSpacing', value)}
                            onChangeAfter={(value) => handleAfterChange('lineSpacing', value)}
                            beforeSuffix={<IconFont name="CharacterSpacingBold" fontSize={14} />}
                            showStepBtn={false}
                        />
                    </div>
                </Tooltip>
                <Tooltip placement="bottom" title={$t((v) => v.textAction.fontSpacing)}>
                    <div className="text-spacing-group__action">
                        <InputNumber
                            min={-150}
                            max={300}
                            value={letterSpacing}
                            onChange={(value) => handleChange('letterSpacing', value)}
                            onChangeAfter={(value) => handleAfterChange('letterSpacing', value)}
                            beforeSuffix={<IconFont name="LineSpacingBold" fontSize={14} />}
                            showStepBtn={false}
                        />
                    </div>
                </Tooltip>
            </div>
        </div>
    );
};
